// DO NOT USE THESE!
// They do not update on browser resize or media query change.

export function isMobileWidth(breakpoint = 768) {
    return window.innerWidth < breakpoint;
}

export function screenSize() {
    return window.innerWidth;
}
